import { type RouteRecordRaw } from "vue-router";
import { RouteNames } from "@shared/types/localTypes/router";

export default {
  path: "/:pathMatch(.*)*",
  name: RouteNames.ErrorNotFound,
  component: () => import("@/views/errors/ErrorPage404.vue"),
} as RouteRecordRaw;
